import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router'
import MediaQuery from 'react-responsive'
import { styled, theme } from '$utils/theme'
import { Block } from '../Layout/Block'
import { Link } from '../Link'
import { rem } from 'polished'
import { Icon } from '../Icon'
import leftArrowIcon from '$icons/leftArrow.svg'
import { DropdownMenu, DropdownItem } from '../DropdownMenu'
import { Logout } from '$views/Logout'
import { routeProvider } from '$utils/routeProvider'
import history from '$utils/history'
import { userGroupService } from '$utils/services/userGroupService'
import { localUserIdData } from '$utils/services/saveUserIdDataService/saveUserIdDataService'
import { useUnreadMessages } from '$utils/hooks/useUnreadMessages'

const proIcon = require('$icons/pro.svg')

interface Props {
  pathGoBack?: string
}

const logo = require('$icons/logoFamiliados.svg')

const HeaderWrapper = styled(Block)`
  width: 100%;
  height: ${rem(72)};
  border-bottom: solid 1px ${p => p.theme.colors.lightGrey};
  background-color: white;
  position: fixed;
  z-index: 3;
`

const HeaderDiv = styled(Block)`
  padding: ${p => rem(p.theme.sizes.base)};
  padding-left: ${p => rem(p.theme.sizes.mini)};
  ${p =>
    p.theme.media.onlyMobile`
      padding-bottom: 0;
      height: 50px;
      border-bottom: solid 1px ${p.theme.colors.lightGrey};
    `};
  height: 71px;
  align-items: center;
  display: flex;
  position: fixed;
  width: 100%;
  background-color: white;
  z-index: 3;
  flex-direction: row;
  justify-content: space-between;
  max-width: 1160px;
  margin: auto;
  left: 0;
  right: 0;
  ${p => p.theme.media.onlyMobile`
    padding-right: ${rem(p.theme.sizes.base)};
    padding-left: ${rem(p.theme.sizes.mini)};
  `};
`

const ProPremiumIcon = styled(Icon)`
  position: relative;
  ${p => p.theme.media.onlyMobile`
    top: -${rem(p.theme.sizes.tiny)};
  `}
`

const HeaderLogo = styled.div`
  display: inline-flex;
  flex-grow: 1;

  ${p =>
    p.theme.media.onlyMobile`
      padding-left: 0;
      img {
        padding-top: 4px;
      }
    `};
  ${p =>
    p.theme.media.desktop`
      padding-top: 7px;
      img {
        transform: scale(1);
      }
    `};
`

const onClickServices = () => history.push(routeProvider.myServices)

const onClickProfile = () => history.push(routeProvider.profile)

const onClickSettings = () => history.push(routeProvider.settings)

const onClickStart = () => history.push(routeProvider.myUserArea)

const onClickCustomerSearcher = () => history.push(routeProvider.caretakerList)

const onClickMessages = () => history.push(routeProvider.chat)

const onClickImagesReviews = () => history.push(routeProvider.imagesReviews)

const onClickOffers = () => history.push(routeProvider.offersForCaretaker)

const onClickGoBack = path => {
  if (path) {
    history.push(path)
  } else {
    history.goBack()
  }
}

const isNormalCustomerOrCallCenter = () => userGroupService.isNormalCustomer() || userGroupService.isCallcenter()

const redirectToProPlan = () => history.push(routeProvider.caretakerPro)

const onClickNursingHomeHelp = () => window.location.assign(routeProvider.nursingHomeHelp)

const isResidence = () => userGroupService.isResidenceAdmin() || userGroupService.isResidenceModerator()

const showProIcon = () => userGroupService.isCaretaker() && !localUserIdData.getUserIdData().hasActiveProSubscription

const DesktopHeaderRaw: React.SFC<RouteComponentProps<any> & Props> = () => (
  <HeaderWrapper>
    <HeaderDiv marginBottom="base">
      <HeaderLogo>
        <Link href={routeProvider.mainPage} title="Familiados">
          <Icon content={logo} logo color="darkGrey" />
        </Link>
      </HeaderLogo>
      {!userGroupService.isGuest() && (
        <>
          {showProIcon() && (
            <ProPremiumIcon
              content={proIcon}
              onClick={redirectToProPlan}
              clickable
              resize={{ height: 25, width: 80 }}
            />
          )}
          <DropdownMenu color="darkGrey">
            {userGroupService.isCustomer() && (
              <>
                {userGroupService.isNormalCustomer() && <DropdownItem onClick={onClickStart}>Inicio</DropdownItem>}
                <DropdownItem onClick={onClickServices}>
                  {isNormalCustomerOrCallCenter() ? 'Mis servicios' : 'Mi área privada'}
                </DropdownItem>
                {userGroupService.isNormalCustomer() && (
                  <DropdownItem onClick={onClickMessages} circle={useUnreadMessages()}>
                    Chat
                  </DropdownItem>
                )}
                <DropdownItem onClick={onClickCustomerSearcher}>Profesionales en tu zona</DropdownItem>
                <DropdownItem onClick={onClickProfile}>Mi perfil</DropdownItem>
                {!userGroupService.isCallcenter() && <DropdownItem onClick={onClickSettings}>Ajustes</DropdownItem>}
                {isResidence() && <DropdownItem onClick={onClickNursingHomeHelp}>Ayuda</DropdownItem>}
              </>
            )}
            {userGroupService.isCaretaker() && (
              <>
                <DropdownItem onClick={onClickOffers}>Ofertas</DropdownItem>
                <DropdownItem onClick={onClickServices}>Mis servicios</DropdownItem>
                <DropdownItem onClick={onClickMessages} circle={useUnreadMessages()}>
                  Chat
                </DropdownItem>
                <DropdownItem onClick={onClickProfile}>Mi perfil</DropdownItem>
                <DropdownItem onClick={onClickSettings}>Ajustes</DropdownItem>
              </>
            )}
            {userGroupService.isAdmin() && (
              <>
                <DropdownItem onClick={onClickServices}>Mi área privada</DropdownItem>
                <DropdownItem onClick={onClickCustomerSearcher}>Profesionales en tu zona</DropdownItem>
                {(process.env.REACT_APP_AUXILIARES as string) === 'true' && (
                  <DropdownItem onClick={onClickImagesReviews}>Revisión imágenes</DropdownItem>
                )}
              </>
            )}
            <Logout />
          </DropdownMenu>
        </>
      )}
    </HeaderDiv>
  </HeaderWrapper>
)

const MobileHeaderRaw: React.SFC<RouteComponentProps<any> & Props> = ({ pathGoBack }) => (
  <HeaderDiv>
    <Link onClick={() => onClickGoBack(pathGoBack)}>
      <Icon content={leftArrowIcon} size="m" />
    </Link>
    {showProIcon() && (
      <ProPremiumIcon content={proIcon} onClick={redirectToProPlan} clickable resize={{ height: 25, width: 60 }} />
    )}
  </HeaderDiv>
)
const DesktopHeader = withRouter(DesktopHeaderRaw)

const MobileHeader = withRouter(MobileHeaderRaw)

const HeaderRaw: React.SFC<RouteComponentProps<any> & Props> = () => (
  <>
    <MediaQuery minWidth={theme.breakpoints.desktop}>
      <DesktopHeader />
    </MediaQuery>
    <MediaQuery maxWidth={theme.breakpoints.desktop - 1}>
      <MobileHeader />
    </MediaQuery>
  </>
)

export const SecondLevelHeader = withRouter(HeaderRaw)



// WEBPACK FOOTER //
// ./src/views/components/Layout/SecondLevelHeader.tsx